import React, { Component } from "react";
import moment from "moment";

export default class Footer extends Component {
  render() {
    return (
      <footer>
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="footer-wrapper">
                <div className="left-side">
                  <img src="./assets/images/eals-footer-logo.png" />
                </div>
                <div className="right-side">
                  <p>
                    EverythingALS is a patient-focused non-profit, part of Peter
                    Cohen Foundation (PCF) a 501(3)c organization
                  </p>
                </div>
              </div>
              <div className="footer-text">
                <p>
                  © {moment().format("YYYY")} - Everything ALS Version 1.4.0.1 -
                  Privacy
                </p>
              </div>
            </div>
          </div>
        </div>
      </footer>
    );
  }
}
